import {
  CartItem,
  CartItemPaymentTerms,
  CartItemType,
} from "@/types/cart-item";
import { Defaults } from "@/types/Defaults";
import { BillingInfo } from "@/types/BillingInfo";
import app_config from "../app_config.json";
import { CartEvent } from "@/types/CartEvent";
import Cookies from "cookies-js";

/**
 * This class is the cart.
 */
export class Cart {
  // Members
  items: CartItem[] = [];
  stateValue: string = "";
  processing_fee: number;
  billing_info: BillingInfo;
  completed: boolean;
  terms_agree: boolean;
  quoteId: number;
  saved: boolean;
  utm_source: string = "";
  utm_medium: string = "";
  utm_campaign: string = "";
  utm_content: string = "";
  orderId: any = null;
  static max_per_type = 6;
  static key = "wagp_cart";

  private readonly onItemsChange = new CartEvent<void>();
  private readonly onItemRemove = new CartEvent<CartItem>();

  /**
   * Default constructor.
   */
  constructor() {
    this.processing_fee = 0;
    this.quoteId = 0;
    this.billing_info = new BillingInfo();
    this.completed = false;
    this.terms_agree = false;
    this.saved = false;
    this.stateValue = "";
    this.readFromStorage();
    this.utm_source = "";
  }

  /**
   * Persists cart state to storage
   */
  persist() {
    // Persist
    const items: any[] = [];
    this.items.forEach((item) => {
      items.push(item.getPersistObject());
    });
    const data = {
      stateValue: this.stateValue,
      items: items,
      processing_fee: this.processing_fee,
      billing_info: this.billing_info.getPersistObject(),
      completed: this.completed,
      quoteId: this.quoteId,
      saved: this.saved,
    };
    console.log("Persist Cart", data);
    window.localStorage.setItem(Cart.key, JSON.stringify(data));
  }

  readFromStorage() {
    const val = window.localStorage.getItem(Cart.key) as string;
    if (!val) {
      return;
    }
    const storageObj = JSON.parse(val);
    if (!storageObj) {
      return;
    }

    this.processing_fee = storageObj.processing_fee;
    this.completed = storageObj.completed;
    this.stateValue = storageObj.stateValue;
    this.quoteId = storageObj.quoteId;
    this.saved = storageObj.saved;
    this.billing_info.fromPersistObject(storageObj.billing_info);
    storageObj.items.forEach((item) => {
      if (item.code) {
        const cart_item = new CartItem(item.code);
        cart_item.fromPersistObject(item);
        this.items.push(cart_item);
      } else {
        return;
      }
    });
  }

  clearStorage() {
    console.log("cleaaar");
    window.localStorage.removeItem("wagp_cart");
  }

  get due_today() {
    let sum = 0;
    this.items.forEach((item) => {
      sum += item.due_today;
    });
    return sum;
  }

  get total() {
    return this.due_today;
  }

  /**
   * Get the total processing fee. The formula to calculate:
   * If there's one or more annual items, you add processing_fee once.
   * You add monthly_processing_fee foreach monthly item.
   */
  get total_processing_fee() {
    let total = 0;
    this.items.forEach((item) => {
      total += item.processing_fee;
    });
    return total;
    // return (
    //   (this.hasAnnualOrRenewItem ? this.processing_fee : 0) +
    //   this.monthlyProcessingFees
    // );
  }

  /**
   * Check if any of the items are InFull or AnnualAutoRenew
   */
  get hasAnnualOrRenewItem() {
    return (
      this.items.find((item) => {
        console.log(item.payment_terms);
        return (
          item.payment_terms == CartItemPaymentTerms.InFull ||
          item.payment_terms == CartItemPaymentTerms.AnnualAutoRenew
        );
      }) != null
    );
  }

  get hasRenewItem() {
    return (
      this.items.find((item) => {
        return item.payment_terms == CartItemPaymentTerms.AnnualAutoRenew;
      }) != null
    );
  }

  /**
   * Calculate processing fee's for each Monthly item.
   */
  get monthlyProcessingFees() {
    return (
      this.items.filter((item) => {
        if (
          item.processing_fee_sku &&
          item.payment_terms == CartItemPaymentTerms.Monthly
        ) {
          return true;
        }
      }).length * app_config.wag_api.order.monthly_processing_fee
    );
  }

  get total_monthly() {
    let sum = 0;
    this.items.forEach((item) => {
      if (
        item.processing_fee_sku &&
        item.payment_terms == CartItemPaymentTerms.Monthly
      ) {
        sum += item.due_today + app_config.wag_api.order.monthly_processing_fee;
      }
    });
    return sum;
  }

  get total_annual() {
    let sum = 0;
    this.items.forEach((item) => {
      if (item.payment_terms == CartItemPaymentTerms.AnnualAutoRenew) {
        sum += item.due_today;
      }
    });
    sum += this.processing_fee;
    return sum;
  }

  get progressive_discount() {
    let sum = 0;

    this.items.forEach((item) => {
      if (item.coverage > 0 && item.deductible > -1 && this.stateValue !== "") {
        sum += item.discount;
      }
    });
    return sum;
  }

  //TODO replace with code
  /**
   * Add count number of CartItems of the specified type,
   * clearing previous CartItems of the specified type.
   * @param item_type
   * @param count
   */
  replaceByCode(code: string, count: number): boolean {
    const arrNotType = this.items.filter((item: CartItem) => {
      return item.code != code;
    });
    let arrType = this.items.filter((item: CartItem) => {
      return item.code == code;
    });
    const originLength = arrType.length;
    // eslint-disable-next-line no-console
    console.log(arrType.length, count);
    if (count == 0) {
      arrType = [];
    } else if (arrType.length > count) {
      arrType = arrType.splice(0, count);
    } else {
      for (let i = 0; i < count - originLength; i++) {
        arrType.push(new CartItem(code));
      }
    }
    this.items = [...arrType, ...arrNotType];
    // if (this.clearByType(item_type)) {
    // for (let i = 0; i < Math.min(count, Cart.max_per_type); i++) {
    //   this.items.push(new CartItem(item_type));
    // }
    this.persist();
    this.onItemsChanged();
    return true;
    // }
    // return false;
  }

  /**
   * Increases number of items in the cart of the specified type.
   * @param itemCode
   */
  increaseOne(itemCode: string) {
    if (this.countByCode(itemCode) == Cart.max_per_type) {
      return false;
    }
    this.items.push(new CartItem(itemCode));
    this.persist();
    this.onItemsChanged();
    return true;
  }

  /**
   * Decrease one item of the specified type.
   * @param code
   */
  decreaseOne(code: string) {
    const index = this.getFirstOfTypeIndex(code);
    if (index >= 0) {
      this.items.splice(index, 1);
      // Un-match any follow up items
      this.items
        .filter((x) => x.code == code)
        .forEach((item) => {
          item.match_with_first = false;
        });
      this.persist();
      this.onItemsChanged();
      return true;
    }
    return false;
  }

  /**
   * Clear all of the items of the specified type.
   * @param item_type
   */
  private clearByType(item_type: CartItemType): boolean {
    // Reject only items of the specified type
    const arr = this.items.filter((item: CartItem) => {
      return item.type != item_type;
    });
    // Empty the list. We do this because we can't just attach
    // the new array to items, because we will loose reactivity.
    this.items = [];
    // Re-add
    arr.forEach((item: CartItem) => {
      this.items.push(item);
    });

    return true;
  }

  /**
   * Get the number of items by type
   */
  countByCode(code: string): number {
    return this.items.filter((x) => x.code == code).length;
  }

  /**
   * Gets first based index of the specified item in the list of items of the same type.
   * @param code
   * @param id
   */
  indexOfCode(code: string, id: number): number {
    let index = 0;
    for (let i = 0; i < this.items.length; i++) {
      if (this.items[i].code == code) {
        index++;
        if (this.items[i].id == id) {
          break;
        }
      }
    }
    return index;
  }

  /**
   * Remove item with the specified id from the list.
   * @param id
   */
  deleteItem(id: number) {
    const index = this.items.findIndex((item) => {
      return item.id == id;
    });
    // If this was first, disable any possible follow up match_with_first items
    if (this.indexOfCode(this.items[index].code, id) == 1) {
      this.items
        .filter((x) => x.code == this.items[index].code)
        .forEach((item) => {
          item.match_with_first = false;
        });
    }
    let item;
    if (index >= 0) {
      item = this.items.splice(index, 1)[0];
    }
    this.persist();
    this.onItemsChanged();
    this.onItemRemoved(item);
  }

  /**
   * Get cart item by the specified id.
   * @param id
   */
  getItemById(id: number) {
    return this.items.find((item) => {
      return item.id == id;
    });
  }

  /**
   * Gets the first item of the specified type
   * @param type
   */
  getFirstOfType(code: string) {
    for (let i = 0; i < this.items.length; i++) {
      if (this.items[i].code == code) {
        return this.items[i];
      }
    }
    return null;
  }

  /**
   * Gets the index of the first item of the specified type
   * @param type
   */
  getFirstOfTypeIndex(code: string) {
    for (let i = 0; i < this.items.length; i++) {
      if (this.items[i].code == code) {
        return i;
      }
    }
    return -1;
  }

  //TODO
  /**
   * Updates coverage values of all of the items that are matched
   * with the specified one.
   * @param master
   */
  updateMatchedItemsCoverage(master: CartItem) {
    const items = this.items.filter((x) => x.code == master.code);
    items.forEach((item) => {
      if (item.match_with_first) {
        item.coverage = master.coverage;
        item.deductible = master.deductible;
        item.due_today = master.due_today;
        item.discount = master.discount;
        item.policy_term = master.policy_term;
        item.payment_terms = master.payment_terms;
        item.processing_fee = master.processing_fee;
        item.sku = master.sku;
        item.processing_fee_sku = master.processing_fee_sku;
        item.installmentPremium = master.installmentPremium;
      }
    });
    if (items.length > 0) {
      this.persist();
    }
  }

  /**
   * Clear only if order has been completed.
   */
  clearIfCompleted() {
    if (this.completed) {
      this.clearAll();
      this.processing_fee = Defaults.getInstance().processingFee;
      this.billing_info = new BillingInfo();
      this.completed = false;
      this.persist();
    }
  }

  /**
   * Clears all cart items
   */
  private clearAll() {
    this.items = [];
  }

  //TODO
  clearCookies() {
    Cookies.expire(CartItemType.eReader.toString());
    Cookies.expire(CartItemType.Camera_iPod.toString());
    Cookies.expire(CartItemType.GamingSystem.toString());
    Cookies.expire(CartItemType.Tablet.toString());
    Cookies.expire(CartItemType.Laptop.toString());
    Cookies.expire(CartItemType.iPad.toString());
    Cookies.expire(CartItemType.Smartphone.toString());
    Cookies.expire(CartItemType.iPhone.toString());
  }

  public get itemsChanged() {
    return this.onItemsChange.expose();
  }

  private onItemsChanged() {
    this.onItemsChange.trigger();
  }

  public get itemRemoved() {
    return this.onItemRemove.expose();
  }
  private onItemRemoved(item: CartItem) {
    this.onItemRemove.trigger(item);
  }
}
